// Matches: "ClassName::ClassName <any text>: <actual message>"
const CLASS_ERROR_PATTERN = /\w+::\w+[^:]*:\s*(?<message>.+)/;

export function filterErrorMessage(errorMessage: string): string {
  if (!errorMessage) {
    return errorMessage;
  }

  // Filters out class name in the error message
  const sentences = errorMessage
    .split(".")
    .map((sentence) => sentence.trim())
    .filter((sentence) => sentence.length > 0);

  const filteredSentences = sentences
    .map((sentence) => {
      if (!sentence.includes("::")) {
        return sentence;
      }
      const match = sentence.match(CLASS_ERROR_PATTERN);
      if (match?.groups?.message) {
        return match.groups.message.trim();
      }
      return null;
    })
    .filter((sentence): sentence is string => sentence !== null);

  const result = filteredSentences.join(". ").trim();
  return result
    ? result + "."
    : "An error occurred while processing your request.";
}
